import { render, staticRenderFns } from "./FileUploaderComponent.vue?vue&type=template&id=ed1f0d04&scoped=true"
import script from "./FileUploaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileUploaderComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FileUploaderComponent.vue?vue&type=style&index=0&id=ed1f0d04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1f0d04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed1f0d04')) {
      api.createRecord('ed1f0d04', component.options)
    } else {
      api.reload('ed1f0d04', component.options)
    }
    module.hot.accept("./FileUploaderComponent.vue?vue&type=template&id=ed1f0d04&scoped=true", function () {
      api.rerender('ed1f0d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/components/ImportExpedientsDialog/components/FileUploaderComponent.vue"
export default component.exports